import { useMemo, useState, useEffect } from 'react';
import { useAuth } from '../guards';

export const useRouteGuard = () => {
  const { user, homepage, isAuthenticated } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  // Track when authentication state is being determined
  useEffect(() => {
    const checkAuthState = () => {
      const token = localStorage.getItem('token');

      // If there's no token, we know immediately the user is not authenticated
      if (!token) {
        setIsLoading(false);
        return;
      }

      // If there's a token but no user yet, we're still loading
      if (token && user === null) {
        setIsLoading(true);
        return;
      }

      // If there's a token and we have user data, we're done loading
      if (token && user) {
        setIsLoading(false);
        return;
      }

      // If there's a token but user is undefined, we're still loading
      if (token && user === undefined) {
        setIsLoading(true);
        return;
      }
    };

    // Check immediately
    checkAuthState();

    // Also check after a small delay to handle async initialization
    const timer = setTimeout(checkAuthState, 150);

    return () => clearTimeout(timer);
  }, [user, isAuthenticated]);

  const redirectTo = useMemo(() => {
    if (isAuthenticated) {
      return homepage;
    }
    return '/login';
  }, [isAuthenticated]);

  return {
    isAuthenticated,
    redirectTo,
    user,
    isLoading,
  };
}; 